export default "/_next/static/images/2017-0a502d1fbad48ab7b4db85580d24904e.svg";